import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Grid,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import "../shared/modern-ui.css";

const UpdateCompanyDetailsForm = () => {
  const [formValues, setFormValues] = useState({
    about_company: "",
    company_address: "",
    city: "",
    profile_link: "",
    profile_image: null,
  });

  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const steps = ["Hakkımızda", "Adres", "Logo"];
  const cities = [
    "Genel","Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
    "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
    "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
    "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
    "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
    "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
    "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
    "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
    "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
    "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"
  ];

  // Mevcut şirket bilgilerini API'den çek
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get("https://kariyer.biyomed.net/api/companies/getOneDetails", {
          withCredentials: true,
        });
        setFormValues(response.data.company);
      } catch (err) {
        console.error("Veri çekme hatası:", err);
      }
    };
    fetchCompanyDetails();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      alert("Geçersiz dosya türü!");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert("Dosya boyutu 5MB'ı geçemez!");
      return;
    }
    setFormValues((prev) => ({ ...prev, profile_image: file }));
  };
  const handleRemoveDocument = (field) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: null,  // Dosyayı null yapıyoruz
    }));
  };
  const isValidUrl = (url) => {
    const regex = /^(https?:\/\/)?([a-z0-9.-]+)(\.[a-z]{2,})((\/[^\s]*)*)$/i;
    return regex.test(url);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    if (!isValidUrl(formValues.profile_link)) {
      alert("Geçerli bir link giriniz")
      setLoading(false)
      return
    }
    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await axios.put(
        "https://kariyer.biyomed.net/api/company/updateCompanyDetails",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        }
      );
      console.log("Güncelleme başarılı:", response.data);
      setLoading(false)
      window.location.href = "/companyprofile";
    } catch (err) {
      console.error("Güncelleme hatası:", err);
      setLoading(false)
    }
  };

  return (
    <div className="bm-page">
      <div className="bm-container">
        <div className="bm-page-head">
          <h1 className="bm-page-title">Firma Detay Bilgileri</h1>
          <p className="bm-page-sub">
            Firma profilinizi tamamlayın — ilanlarınızda bu bilgiler görünür.
          </p>
        </div>

        <div className="bm-card">
          <div className="bm-card-head" style={{ display: "block", padding: "24px" }}>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>

          <Box component="form" className="bm-card-body">
            {activeStep === 0 && (
              <Grid container spacing={2.5}>
                <Grid item xs={12}>
                  <label className="bm-label">Firma Hakkında</label>
                  <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    name="about_company"
                    value={formValues.about_company}
                    onChange={handleInputChange}
                  />
                  <span className="bm-hint">
                    Firmanızı kısaca tanıtın — adaylar ilanlarınızda bu metni görür.
                  </span>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <label className="bm-label">Profil Linki</label>
                  <TextField
                    fullWidth
                    size="small"
                    name="profile_link"
                    value={formValues.profile_link}
                    onChange={handleInputChange}
                  />
                  <span className="bm-hint">Örnek: www.firmaniz.com</span>
                </Grid>
              </Grid>
            )}

            {activeStep === 1 && (
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6}>
                  <label className="bm-label">İl</label>
                  <Select
                    name="city"
                    size="small"
                    displayEmpty
                    value={formValues.city}
                    onChange={handleInputChange}
                    style={{ width: "100%"}}
                  >
                    <MenuItem value="" disabled>İl Seçiniz</MenuItem>
                    {cities.map((city, index) => (
                      <MenuItem key={index} value={city}>
                        {city}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label className="bm-label">Firma Adresi</label>
                  <TextField
                    fullWidth
                    size="small"
                    name="company_address"
                    value={formValues.company_address}
                    onChange={handleInputChange}
                  />
                </Grid>


              </Grid>
            )}

            {activeStep === 2 && (
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={8}>
                  <label className="bm-label">Firma Logosu</label>
                  <div className={`bm-upload${formValues.profile_image ? " bm-upload--filled" : ""}`}>
                    <span className="bm-upload-icon">
                      <i className={`fa ${formValues.profile_image ? "fa-check" : "fa-cloud-upload"}`} />
                    </span>
                    <span className="bm-upload-text">
                      <span className="bm-upload-title">
                        {formValues.profile_image ? "Firma logosu yüklendi" : "Firma logosu yükle"}
                      </span>
                      <span className="bm-upload-sub">
                        {formValues.profile_image?.name
                          ? formValues.profile_image.name
                          : "JPG veya PNG · en fazla 5MB"}
                      </span>
                    </span>
                    <input
                      type="file"
                      name="profile_image"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleDocumentChange}
                    />
                  </div>
                  {formValues.profile_image && (
                    <button
                      type="button"
                      className="bm-upload-remove"
                      onClick={() => handleRemoveDocument("profile_image")}
                    >
                      <i className="fa fa-trash" /> Dosyayı Sil
                    </button>
                  )}
                </Grid>
              </Grid>
            )}
          </Box>

          <div className="bm-form-footer">
            <Button
              disabled={activeStep === 0}
              onClick={handleBack}
              variant="outlined"
              sx={{ textTransform: "none", borderRadius: "10px", px: 2.5, fontWeight: 600 }}
            >
              Geri
            </Button>
            {activeStep < steps.length - 1 ? (
              <Button
                onClick={handleNext}
                variant="contained"
                sx={{ textTransform: "none", borderRadius: "10px", px: 3, fontWeight: 600 }}
              >
                İleri
              </Button>
            ) : (
              <Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                disabled={loading}
                sx={{ textTransform: "none", borderRadius: "10px", px: 3, fontWeight: 600 }}
              >
                {loading ? <CircularProgress size={22} color="inherit" /> : "Kaydet"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCompanyDetailsForm;
